<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box">
      <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
      <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--</div>-->
      <div class="row-li">
        <div class="flex-center">
          <img src="../../../assets/images/other/de-left.png" alt="">
          <!-- <div class="s-title">啦啦操赞助商</div> -->
          <div class="s-title">联系我们</div>
          <img src="../../../assets/images/other/de-right.png" alt="">
        </div>
      </div>

      <!-- <div class="logo-ul">
        <div class="logo-li" :key="i" v-for="(row,i) in list">
          <img v-rblink="{name:'NewsDetail',query:{id:row.id}}" :src="row.pic_url"/>
        </div>
      </div> -->


      <div :key="index" v-for="(item,index) in zslist">
        <div class="row-li">
          <div class="flex-center">
            <img src="../../../assets/images/other/de-left.png" alt="">
            <div class="s-title">{{item.title}}</div>
            <img src="../../../assets/images/other/de-right.png" alt="">
          </div>
        </div>
        <div class="row-banner" v-rblink="{name:'NewsDetail',query:{id:item.id}}" >
          <img :src="item.pic_url" alt="">
        </div>
      </div>

        <div class="row-contact">
          <img src="../../../assets/images/other/contact.png" alt="">
        </div>


<!--      <div class="row-zhaoshang flex-between">-->
<!--        <div class="row-zhaoshang-left" v-rblink="{name:'NewsList',query:{cate_id:44}}">-->
<!--          <img src="../../../assets/images/other/bg-saishizhaoshang.png" alt="">-->
<!--        </div>-->
<!--        <div class="row-zhaoshang-right">-->
<!--          <img src="../../../assets/images/other/icon-huodongzhaoshang.png" alt="" v-rblink="{name:'NewsList',query:{cate_id:52}}">-->
<!--          <img src="../../../assets/images/other/bg-shangwuzhaoshang.png" alt=""  v-rblink="{name:'NewsList',query:{cate_id:50}}">-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="row3">-->
<!--        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in catelist" v-if="i>=1"-->
<!--             :src="row.pic_url"/>-->
<!--        <div style="clear: both"></div>-->
<!--      </div>-->


    </div>
  </div>
</template>
<style scoped>
.row-banner,.row-contact {
  margin: 0 .2rem;
}


.row-banner img, .row-contact img {
  width: 100%;
}

.row-zhaoshang {
  margin: .3rem .2rem;
}

.row-zhaoshang-left img {
  width: 3.3rem;
}

.row-zhaoshang-right {
  text-align: right;
}

.row-zhaoshang-right img {
  width: 3.7rem;
}

.row-li {
  margin: .3rem 0 .2rem;
}

.row-li img {
  height: 15px;
}

.s-title {
  margin: 0 .1rem;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}

.row1 {
  /*padding: 10px;*/
  margin: 0 10px;
}

.row1 img {
  width: 100%;
  margin: 10px 0 0 0;
}

.row3 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}

.row3 img {
  float: left;
  width: calc(33.33% - 10px);
  margin: 0 10px 10px 0;
}

.logo-ul {
  /*background: #fff;*/
  /*border-radius: 10px;*/
  /*height: 100px;*/
  margin: 0 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/*.logo-ul div{*/
/*  text-align: center;*/
/*  float: left;*/
/*  width: calc(50% - 10px);*/
/*  margin: 0 0 10px 10px;*/
/*  line-height: 110px;*/
/*  height: 110px;*/
/*}*/
/*.logo-ul img{*/
/*  width: 100%;*/
/*  display: inline-block;*/
/*}*/

.logo-li {
  width: 49%;
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.05);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-li img {
  width: 110px;
}

</style>

<script>
import Vue from "vue";
import {Tab, Tabs, List, PullRefresh, Toast} from "vant";

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(Toast);

export default {
  name: "NewsList",
  components: {},

  data: function () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [],
      catelist: [],
      list: [],
      zslist: [],
      params: {
        parent_id: 39
      },
    };
  },
  filters: {},
  mounted() {
    document.title = "商务合作";
    this.fetch();
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
          "/api/cms/catelist", {
            parent_id: 39
          },
          res => {
            that.catelist = res.data
          },
          res => {
            Toast(res.msg);
          }
      );
      that.$api.get(
          "/api/cms/cmsList", {
            cate_id: 53,
            pageNo: 1,
            pageSize: 100
          },
          res => {
            that.list = res.data.list
          },
          res => {
            Toast(res.msg);
          }
      );

      that.$api.get(
          "/api/cms/cmsList", {
            cate_id: 41,
            pageNo: 1,
            pageSize: 100
          },
          res => {
            that.zslist = res.data.list
          },
          res => {
            Toast(res.msg);
          }
      );
      
    },
  }
};
</script>



// WEBPACK FOOTER //
// Saishizhaoshang.vue?b2b0fa96